export default {
  countries (state) {
    return {
      ...state,
      storeName: 'countries'
    }
  }
}
